import { debounce } from "@/libs/tools";

// 添加事件监听
const addListener = (el, type, fn) => {
  el.addEventListener(type, fn, false);
};

//去掉空格
const spaceFilter = el => {
  addListener(el, "input", () => {
    el.value = el.value.replace(/\s+/, "");
  });
};

// 限制只能输入整数和小数（价格类、最多两位小数）
const priceFilter = el => {
  addListener(
    el,
    "input",
    debounce(() => {
      el.value = el.value.match(/^\d*(\.?\d{0,2})/g)[0] || null;
      if (isNaN(el.value)) {
        el.value = "";
      }
    })
  );
};

// 限制只能输入正整数
const IntFilter = el => {
  addListener(
    el,
    "input",
    debounce(() => {
      el.value = el.value.replace(/\D/g, "");
    })
  );
};

const vaidate = {
  mounted(el, binding) {
    if (el.tagName.toLowerCase() !== "input") {
      el = el.getElementsByTagName("input")[0];
    }
    spaceFilter(el);
    switch (binding.arg) {
      case "price":
        priceFilter(el);
        break;
      case "int":
        IntFilter(el);
        break;
      default:
        console.warn("未知指令类型", binding.arg);
        break;
    }
  }
};

export default vaidate;
